import React from 'react';
import PropTypes from 'prop-types';
import {
  Block,
  Icon,
  Link,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Page
} from 'framework7-react';
import { DOC_TYPE_DOCUMENT } from '../helpers/utils';
import OpenMainInfoLink from '../common/OpenMainInfoLink';
import MobileDocEntry from './MobileDocEntry';
import II18 from '../translate/II18';
import {
  ExpiredWarningBlock,
  ListHeaderBlock,
  RequestStepperNextButton,
  SecurityInfoBlock,
  SendButtonBlock,
  SuccessMessageBlock
} from './Elements';

import { gaClickOnDocType, gaeList, gaListPageView } from './ga';
import { f7navigator } from '../helpers/navigator';
import { POPUP_THANKYOU } from '../desktop/DesktopMainPage';
import ImageDocumentUploader from '../common/ImageDocumentUploader';

class MobileDocumentsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sendInfoFiles: false,
      currentActionForDocType: props.showThankyouPopUp ? POPUP_THANKYOU : false
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.oneDocumentStep &&
      (prevProps.currentRequestPageIndex !==
        this.props.currentRequestPageIndex ||
        (prevProps.summaryStep && !this.props.summaryStep))
    ) {
      this.props.navigateToMobileDocument(
        this.props.requestedDocuments[0],
        !this.props.requestStepMovedForward
      );
    }
  }

  onPageIn = () => {
    gaListPageView();

    if (this.props.cameraMode !== null) {
      this.props.setCameraMode(null);
    }
  };

  showCropper = docId => {
    this.setState({
      showUploadActionsForDocId: ''
    });
    f7navigator.toImageCropper(docId);
  };

  showSortGallery = docId => {
    this.setState({
      showUploadActionsForDocId: ''
    });
    f7navigator.toGallery(docId, { doNotModifyCameraMode: true });
  };

  onDocumentEntryClick = (document, actionDirectOnPageIndex) => {
    const readOnlyEntry = this.props.scanEnded || document.submitted;

    if (actionDirectOnPageIndex !== undefined) {
      this.props.goToRequestPage(actionDirectOnPageIndex);
      this.props.navigateToMobileDocument(document);
    } else {
      switch (document.type) {
        case DOC_TYPE_DOCUMENT:
          gaClickOnDocType(document.type, document.id.substring(0, 4));
          if (document.done || document.rejected || readOnlyEntry) {
            this.props.navigateToMobileDocument(document);
          } else {
            gaeList('UPLOAD_ACTIONS_MENU', 'SHOW');
            this.setState({
              showUploadActionsForDocId: document.id
            });
          }
          break;

        default:
          this.props.navigateToMobileDocument(document);
      }
    }
  };

  render = () => {
    const {
      expired,
      scanEnded,
      forms,
      documentsStatus,
      successSentKeys,
      errorSentKeys,
      templateMode,
      privacyAccepted,
      setPrivacyAccepted,
      requestedDocuments,
      isDocumentsReadyToSend,
      onlyInfoDocuments,
      haveDocumentsToSend,
      infoMessage,
      errorMessage,
      getScannedPages,
      activePageTitle,
      isManyPagesRequest,
      caseName,
      companyName,
      submittedDate,
      haveDocumentsToUpload,
      activePageDone,
      activePageIndex,
      goToNextRequestPage,
      highlightDocument,
      summaryStep,
      onSendRequest,
      pagesInfo,
      customConfirmationPageText,
      completeButtonLabel,
      skipStartPage,
      embedMode,
      navigateBack,
      usersDataOk,
      onRejectDocument
    } = this.props;

    const { showUploadActionsForDocId } = this.state;

    const listDocuments = (docs, actionDirectOnPageIndex) =>
      docs
        .filter(doc => !(doc.optional && scanEnded) || doc.done)
        .map(document => (
          <MobileDocEntry
            animateEntry={highlightDocument === document.id}
            key={document.id}
            document={document}
            scannedPages={getScannedPages(document.id)}
            forms={forms}
            documentsStatus={documentsStatus}
            onMobileUploadClick={() =>
              this.onDocumentEntryClick(document, actionDirectOnPageIndex)
            }
            scanEnded={scanEnded}
            successSentKeys={successSentKeys}
            errorSentKeys={errorSentKeys}
          />
        ));
    const hasStepperPrevPage = isManyPagesRequest && activePageIndex > 0;

    return (
      <Page onPageBeforeIn={this.onPageIn} onPageAfterIn={this.onPageAfterIn}>
        <Navbar>
          {(!skipStartPage ||
            hasStepperPrevPage ||
            window.standalone ||
            embedMode) && (
            <NavLeft>
              <Link id={'navigateBack'} onClick={() => navigateBack(true)}>
                <Icon ios="f7:chevron_left" md="material:arrow_back" />{' '}
                {this.$f7.device.ios ? II18.get('title_back') : ''}
              </Link>
            </NavLeft>
          )}

          <NavTitle>{caseName}</NavTitle>

          <NavRight>
            <OpenMainInfoLink>
              <Icon size="25" icon="fas fa-info-circle" />
            </OpenMainInfoLink>
          </NavRight>
        </Navbar>

        <div className={'documents-list'}>
          {requestedDocuments?.length || summaryStep ? (
            <div>
              {summaryStep ? (
                customConfirmationPageText ? (
                  <p
                    style={{ padding: 15, margin: '20px' }}
                    id={'customMessageBlock'}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: customConfirmationPageText
                      }}
                    />
                  </p>
                ) : (
                  <div>
                    {!scanEnded && (
                      <p style={{ padding: 15 }}>
                        {II18.get('request_stepper_check_and_send')}
                      </p>
                    )}
                    {pagesInfo
                      .filter(page => !page.summaryStep)
                      .map((page, index) => (
                        <div key={index}>
                          {listDocuments(page.documents, index)}
                        </div>
                      ))}
                  </div>
                )
              ) : (
                <div>
                  <ListHeaderBlock
                    onlyInfoDocuments
                    scanEnded={scanEnded}
                    expired={expired}
                    pageTitle={activePageTitle}
                  />
                  {listDocuments(requestedDocuments)}
                </div>
              )}

              {(!onlyInfoDocuments || scanEnded) &&
                (scanEnded ? (
                  <div>
                    {expired ? (
                      <ExpiredWarningBlock />
                    ) : (
                      <SuccessMessageBlock submittedDate={submittedDate} />
                    )}
                  </div>
                ) : (
                  (!isManyPagesRequest || summaryStep) && (
                    <>
                      <SecurityInfoBlock
                        companyName={companyName}
                        scanEnded={scanEnded}
                      />
                      <SendButtonBlock
                        className={'mobile-send-block'}
                        privacyAccepted={privacyAccepted}
                        onPrivacyClick={() =>
                          setPrivacyAccepted(!privacyAccepted)
                        }
                        desktop={window.isDesktop}
                        templateMode={templateMode}
                        haveDocumentsToSend={haveDocumentsToSend}
                        allRequiredOk={isDocumentsReadyToSend}
                        usersDataOk={usersDataOk}
                        completeButtonLabel={completeButtonLabel}
                        onClick={() => {
                          onSendRequest();
                        }}
                      />
                    </>
                  )
                ))}

              {!scanEnded && isManyPagesRequest && !summaryStep && (
                <RequestStepperNextButton
                  slot="fixed"
                  onClick={goToNextRequestPage}
                  hideIcon={!activePageDone}
                />
              )}
            </div>
          ) : (
            <Block>
              <p
                data-testid="requestInProcessMessage"
                style={{ textAlign: 'center' }}
              >
                <II18>list_request_processing</II18>
              </p>
            </Block>
          )}
        </div>

        {haveDocumentsToUpload && (
          <ImageDocumentUploader
            allowReject={true}
            onRejectDocument={() => onRejectDocument(showUploadActionsForDocId)}
            opened={Boolean(showUploadActionsForDocId)}
            documentId={showUploadActionsForDocId || ''}
            onActionsClosed={() =>
              this.setState({ showUploadActionsForDocId: false })
            }
            allowMultiply={true}
            onAfterAddImages={this.showSortGallery}
            onBeforeAddImages={this.showCropper}
          />
        )}

        <Block id={'infoMessage'} style={{ textAlign: 'center' }}>
          {infoMessage && <span style={{ color: 'blue' }}>{infoMessage}</span>}
        </Block>

        <Block id={'errorMessage'} style={{ textAlign: 'center' }}>
          {errorMessage && <span style={{ color: 'red' }}>{errorMessage}</span>}
        </Block>
      </Page>
    );
  };
}

MobileDocumentsList.propTypes = {
  onRejectDocument: PropTypes.func,
  goToRequestPage: PropTypes.func,
  pagesInfo: PropTypes.array,
  activePageDone: PropTypes.bool,
  selectedLang: PropTypes.string,
  brandingDetails: PropTypes.object,
  cameraMode: PropTypes.bool,
  caseName: PropTypes.string,
  companyEmail: PropTypes.string,
  companyName: PropTypes.string,
  documentsStatus: PropTypes.object,
  errorMessage: PropTypes.string,
  expired: PropTypes.bool,
  forms: PropTypes.object,
  infoMessage: PropTypes.string,
  privacyAccepted: PropTypes.bool,
  requestedDocuments: PropTypes.array,
  scanEnded: PropTypes.bool,
  scannedDocuments: PropTypes.object,
  setCameraMode: PropTypes.func,
  setPrivacyAccepted: PropTypes.func,
  showThankyouPopUp: PropTypes.bool,
  submittedDate: PropTypes.string,
  successSentKeys: PropTypes.object,
  errorSentKeys: PropTypes.object,
  templateMode: PropTypes.bool,
  requestPages: PropTypes.any,
  setCurrentRequestPageIndex: PropTypes.func,
  currentRequestPageIndex: PropTypes.number,
  isDocumentsReadyToSend: PropTypes.bool,
  onlyInfoDocuments: PropTypes.bool,
  haveDocumentsToSend: PropTypes.bool,
  getScannedPages: PropTypes.func,
  activePageTitle: PropTypes.string,
  isManyPagesRequest: PropTypes.bool,
  haveDocumentsToUpload: PropTypes.bool,
  goToNextRequestPage: PropTypes.func,
  goToPrevRequestPage: PropTypes.func,
  activePageIndex: PropTypes.number,
  highlightDocument: PropTypes.string,
  actionDocument: PropTypes.object,
  oneDocumentStep: PropTypes.bool,
  skipStartPage: PropTypes.bool,
  embedMode: PropTypes.bool,
  summaryStep: PropTypes.bool,
  customConfirmationPageText: PropTypes.string,
  completeButtonLabel: PropTypes.string,
  requestStepMovedForward: PropTypes.bool,
  onSendRequest: PropTypes.func,
  navigateBack: PropTypes.func,
  usersDataOk: PropTypes.bool,
  componentId: PropTypes.string,

  //withDesktopUpload
  loadDesktopImage: PropTypes.func,

  //withDocumentRootLogic
  navigateToMobileDocument: PropTypes.func,
  currentActionForDocId: PropTypes.string,
  currentActionForDocType: PropTypes.string,
  onPopupClose: PropTypes.func
};

export default MobileDocumentsList;
